import { ImageContent } from '@models';
import { trackingService } from '@services';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './image-content.component.hbs';

export class ImageContentComponent extends BaseContentComponent<ImageContent> {
    protected override customTemplatePropertyName = 'imageContent';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        trackingService.trackBannerImpression(this.data.id, this.data.campaignId);

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                trackingService.trackBannerClick(this.data!.id, this.data!.campaignId);
            });
        });
    }
}
